export class BitacoraCargaDatosModel {
    public BitacoraId: number;   
    public carga:string;   
    public cargaId:number;
    // public Fecha: Date;
    // public Actividad: string;
    // public Procesado: number;
    // public ProcesadoTexto: string;
    // public Respuesta: string;
    // public EventoId: string;
    // public Parametro: string;
    // public TotalRegistros: number;

    constructor() {
        this.BitacoraId = -1;  
        this.carga='';
        this.cargaId=0;
        // this.Actividad = '';
        // this.Procesado = 0;
        // this.ProcesadoTexto = 'No';
        // this.Respuesta = '';
        // this.EventoId
      }
}
